import React, { useState } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

import { mediaSettleHistory } from 'lib/api/media';

import TableContainer from 'components/molecules/MbTable';

let initParam = {
  uri: '/report/mediasettle/mcount/history',
};
const History = ({ location }) => {
  const { mediaId } = queryString.parse(location.search);
  if (typeof mediaId !== 'undefined') {
    initParam.mediaId = mediaId;
  }

  const [params] = useState(initParam);

  return (
    <>
      <TableContainer
        dataReqPromise={mediaSettleHistory}
        params={{ ...params }}
        sort="desc"
        order="ALT_DTTM"
        dense={true}
        hasExcel
      />
    </>
  );
};

export default withRouter(History);
